import { Component, OnInit } from '@angular/core';
import { Temporal } from '@js-temporal/polyfill';
import { InterventionDayListModel } from './Intervention-day-list.model';

@Component({
    selector: 'app-weekly-list',
    templateUrl: './weekly-list.component.html',
    styleUrl: './weekly-list.component.scss',
    standalone: true
})
export class WeeklyListComponent implements OnInit {

    InterventionDayListModel: InterventionDayListModel[] = [];

    constructor() {
        /**
         * TEST DATA
         */
        this.InterventionDayListModel.push({ Date: Temporal.Now.plainDateISO(), NumberOfInterventions: 3, NumberOfMesures: 21 })
        this.InterventionDayListModel.push({ Date: Temporal.Now.plainDateISO().add({ days: 1 }), NumberOfInterventions: 5, NumberOfMesures: 22 })
        this.InterventionDayListModel.push({ Date: Temporal.Now.plainDateISO().add({ days: 2 }), NumberOfInterventions: 3, NumberOfMesures: 26 })
        this.InterventionDayListModel.push({ Date: Temporal.Now.plainDateISO().add({ days: 3 }), NumberOfInterventions: 4, NumberOfMesures: 10 })
        this.InterventionDayListModel.push({ Date: Temporal.Now.plainDateISO().add({ days: 6 }), NumberOfInterventions: 3, NumberOfMesures: 14 })
        this.InterventionDayListModel.push({ Date: Temporal.Now.plainDateISO().add({ days: 7 }), NumberOfInterventions: 3, NumberOfMesures: 11 })
        this.InterventionDayListModel.push({ Date: Temporal.Now.plainDateISO().add({ days: 8 }), NumberOfInterventions: 4, NumberOfMesures: 23 })

    }

    getColorByDay(date: Temporal.PlainDate) {

        switch (date.dayOfWeek) {
            case 1:
                return "blue";
            case 2:
                return "green";
            case 3:
                return "orange";
            case 4:
                return "yellow";
            case 5:
                return "red";
        }
        return "grey";
    }

    ngOnInit(): void {
    }

}
